import {useSelector} from 'react-redux'
import {useIsSeoSRP} from 'hooks/useIsSeoSRP'
import {getIsNoDatesSearch} from 'modules/search/selectors'

export const useDatelessSeoSRP = () => {
  const isSeoSRP = useIsSeoSRP()
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)

  return isSeoSRP && isNoDatesSearch
}
